import { NgModule, LOCALE_ID } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { ComponentsModule } from 'src/app/components/components.module';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { HttpClientModule, HttpClient } from '@angular/common/http';

import { FingerprintAIO } from '@ionic-native/fingerprint-aio/ngx';

import { OpenNativeSettings } from '@ionic-native/open-native-settings/ngx';
import { DefaultModalComponent } from './components/modals/default-modal/default-modal.component';
import { Diagnostic } from '@ionic-native/diagnostic/ngx';

import { CallNumber } from '@ionic-native/call-number/ngx';
import { SocialSharing } from '@ionic-native/social-sharing/ngx';
import { BarcodeScanner } from '@ionic-native/barcode-scanner/ngx';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { ScreenOrientation } from '@ionic-native/screen-orientation/ngx';
import { Market } from '@ionic-native/market/ngx';
import { AuthGuard } from './guards/auth.guard';
import { AngularFittextModule } from 'angular-fittext';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from "ng-recaptcha";
import { AndroidPermissions } from '@awesome-cordova-plugins/android-permissions/ngx';
import { File } from '@awesome-cordova-plugins/file/ngx';

import es from '@angular/common/locales/es';
import { registerLocaleData } from '@angular/common';
import { TranslateConfigService } from './services/commons/translate-config.service';
import { VaelsysWebrtcLibModule } from 'vaelsys-webrtc-lib';
import { NgxVideoTimelineModule } from 'libs/ngx-video-timeline';
import { environment } from 'src/environments/environment';

registerLocaleData(es);

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
    declarations: [AppComponent],
    imports: [
        BrowserModule,
        IonicModule.forRoot(),
        AppRoutingModule,
        HttpClientModule,
        AngularFittextModule,
        BrowserAnimationsModule,
        ToastrModule.forRoot(),
        PdfViewerModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            }
        }),
        ComponentsModule,
        NgxVideoTimelineModule,
        VaelsysWebrtcLibModule.forRoot({
            apiUrl: environment.VAELSYS_CONFIG.apiUrl,
            wsUrl: environment.VAELSYS_CONFIG.wsUrl,
            wsRealm: environment.VAELSYS_CONFIG.wsRealm,
            iceServers:[
                {
                    urls: environment.VAELSYS_CONFIG.iceServers[0].url
                },
                {
                    urls: environment.VAELSYS_CONFIG.iceServers[1].url
                }
            ]
        }),
        RecaptchaV3Module
        
    ],
    providers: [
        StatusBar,
        SplashScreen,
        FingerprintAIO,
        OpenNativeSettings,
        DefaultModalComponent,
        Diagnostic,
        CallNumber,
        SocialSharing,
        BarcodeScanner,
        InAppBrowser,
        ScreenOrientation,
        Market,
        AuthGuard,
        File,
        AndroidPermissions,
        { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
        { provide: LOCALE_ID,
            deps: [TranslateConfigService],
            useFactory: (translateConfigService) => translateConfigService.getCurrentLanguage()
        },
        { provide: RECAPTCHA_V3_SITE_KEY, useValue: environment.RECAPTCHA_V3_KEY }
    ],
    bootstrap: [AppComponent]
})
export class AppModule {}
